import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getHorizontalViewQuery,
  getSubjectGroupPOIQuery,
  getPlannerElementSetQuery,
  getSubjectGroupOverviewQuery,
  getSubjectOverviewQuery,
  getSubjectPOIQuery,
  getSubjectGroupPoiV2Query,
  getUnitPlansOfSubjectAcrossGradesQuery,
  getGradesOfSubjectQuery,
  getOrganizationPlannerTemplatesByGradesQuery,
  getOrganizationSubjectGroupIdsQuery,
  getSubjectGroupTimelineViewQuery,
  getOrganizationSubjectsBasicDetailsQuery,
  getOverallProgrammeInsightsQuery,
  getPlannerElementSetBasicDetailsQuery,
  getSubjectInsightsQuery,
  getUnitPlansOfGradeQuery,
  getOrganizationGradesSubjectsQuery,
  getGradeSubjectsWithSubjectGroupQuery,
  getOrganizationInsightUnitPlansQuery,
  getOrganizationGradesWithUnitCountQuery,
  getInsightsIncludedUnitCountQuery,
  getGradePOIQuery,
  getPypPlannerThemeNodesQuery,
  getPYPProgrammeInsightsQuery,
  getBenchmarkInsightQuery,
  getSubjectOverviewV2Query,
  getGradeBasicDetailsQuery,
  getCustomPlannerElementSetsQuery,
  getOrganizationTemplateIdsQuery,
} from "./Queries";

export const getPlannerElementSetFromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getPlannerElementSetQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getPlannerElementSetBasicDetailsFromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getPlannerElementSetBasicDetailsQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCustomPlannerElementSetsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getCustomPlannerElementSetsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectGroupPOIFromCache = ({
  id,
  uids,
  filters,
  showDetailedView,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSubjectGroupPOIQuery,
      variables: { id, uids, filters, showDetailedView },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectGroupOverviewFromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSubjectGroupOverviewQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectOverviewFromCache = ({ id, uids, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSubjectOverviewQuery,
      variables: { id, uids, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectOverviewV2FromCache = ({ variables }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSubjectOverviewV2Query,
      variables: { ...variables },
    });
  } catch (e) {
    console.warn(e);
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectPOIFromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSubjectPOIQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectGroupPoiV2FromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getSubjectGroupPoiV2Query,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getHorizontalViewFromCache = ({
  id,
  uids,
  filters,
  isDP = false,
  detailedView = true,
  subjectFilters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getHorizontalViewQuery,
      variables: { id, uids, filters, isDP, detailedView, subjectFilters },
    });
  } catch (e) {
    console.warn(e);
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getUnitPlansOfSubjectAcrossGradesFromCache = ({ id, filters }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getUnitPlansOfSubjectAcrossGradesQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getGradesOfSubjectFromCache = ({ id }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getGradesOfSubjectQuery,
      variables: { id },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationPlannerTemplatesByGradesFromCache = ({
  id,
  gradeIds,
  templateFilters,
  plannerTemplateFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationPlannerTemplatesByGradesQuery,
      variables: {
        id,
        gradeIds,
        templateFilters,
        plannerTemplateFilters,
      },
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};
export const getOrganizationSubjectGroupIdsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectGroupIdsQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getSubjectGroupTimelineViewFromCache = ({ id, uids, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectGroupTimelineViewQuery,
      variables: { id, uids, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationSubjectsBasicDetailsFromCache = ({
  organizationId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsBasicDetailsQuery,
      variables: { organizationId, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getOverallProgrammeInsightsFromCache = ({
  curriculumProgramId,
  curriculumProgramType,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOverallProgrammeInsightsQuery,
      variables: { curriculumProgramId, curriculumProgramType, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getSubjectInsightsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectInsightsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getUnitPlansOfGradeFromCache = ({
  id,
  filters,
  uids,
  isDP = false,
  subjectFilters,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getUnitPlansOfGradeQuery,
      variables: { id, filters, uids, isDP, subjectFilters },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationGradesSubjectsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationGradesSubjectsQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getGradeSubjectsWithSubjectGroupFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGradeSubjectsWithSubjectGroupQuery,
      variables: { id },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationInsightUnitPlansFromCache = ({
  id,
  fieldUids,
  filters,
  after,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationInsightUnitPlansQuery,
      variables: {
        id,
        filters,
        after,
        fieldUids,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getInsightsIncludedUnitCountFromCache = ({
  id,
  academicYears,
  curriculumProgramIds,
  fetchTransdisciplinaryCount = false,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getInsightsIncludedUnitCountQuery,
      variables: {
        id,
        academicYears,
        curriculumProgramIds,
        fetchTransdisciplinaryCount,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getOrganizationGradesWithUnitCountFromCache = ({
  id,
  filters,
  unitPlanFilters,
  searchText,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationGradesWithUnitCountQuery,
      variables: {
        id,
        filters,
        unitPlanFilters,
        searchText,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getGradePOIFromCache = ({ id, uids, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGradePOIQuery,
      variables: {
        id,
        uids,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getPypPlannerThemeNodesFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPypPlannerThemeNodesQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getPYPProgrammeInsightsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPYPProgrammeInsightsQuery,
      variables: { id, filters },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getBenchmarkInsightFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getBenchmarkInsightQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", []);
  else return [];
};

export const getGradeBasicDetailsFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGradeBasicDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationTemplateIdsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getOrganizationTemplateIdsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
